import { IAppState } from '@myStore/app.state';
import { IUsersViewState } from '@myStore/users-view/users-view.state';
import { createSelector } from '@ngrx/store';

const usersViewSelector = (state: IAppState) => state.usersView;

export const selectUsers = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.users?.listInfo
);

export const selectUsersLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.users.isLoading
);

export const selectStudents = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.students.listInfo
);

export const selectStudentsLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.students.isLoading
);

export const selectGroupTeachers = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.teachers.listInfo
);

export const selectGroupTeachersLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.teachers.isLoading
);

export const selectStudentNotes = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.notes.listInfo
);

export const selectStudentNote = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.notes.detail
);

export const selectStudentNotesLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.notes.isLoading
);

export const selectStudentGroupsResults = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.groupsResults.results
);

export const selectStudentGroupsResultsLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.groupsResults.isLoading
);

export const selectGenerateStudentResults = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.finalGenerateResults.results
);

export const selectGenerateStudentResultsLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.finalGenerateResults.isLoading
);

export const selectFinalStudentResults = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.finalResults.results
);

export const selectFinalStudentResultsLoading = createSelector(
  usersViewSelector,
  (state: IUsersViewState) => state?.finalResults.isLoading
);
